import React, { Component } from 'react';
import PropTypes from 'prop-types';
import firebase from 'firebase';
import AdminCompaniesView from '../views/AdminCompaniesView';
import { base } from '../../base';

class AdminCompaniesContainer extends Component {
    constructor(props) {
        super(props);
        this.state = {
            companies: [],
        };
    }

    componentWillMount() {
        this.valuesRef = base.syncState('companies', {
            context: this,
            state: 'companies',
            asArray: true,
        });
    }

    componentWillUnmount() {
        base.removeBinding(this.valuesRef);
    }

    render() {
        const { companies } = this.state;
        const { user } = this.props;
        return (
            <AdminCompaniesView
                companies={companies}
                user={user}
            />
        );
    }
}
AdminCompaniesContainer.propTypes = {
    user: PropTypes.instanceOf(firebase.auth.UserCredential).isRequired,
};

export default AdminCompaniesContainer;



// WEBPACK FOOTER //
// ./src/components/containers/AdminCompaniesContainer.js